import { FormControl, Grid, TextField } from "@mui/material";
import React, { useRef, useState } from "react";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { GetUTCTime } from "../../../Helpers/GetUTCTime";
import { UpdateTemplateDataSpecific } from "../../../Helpers/ApiCall";
import moment from "moment";
import DoneIcon from "@mui/icons-material/Done";
import { filterPdfTemplateData, mergePdfDataArray } from "../../../Helpers/HelperFunctions";

function YearElement({
  element,
  elementType,
  pdfCategoriesType,
  templateId,
  level,
  pdfCategoryData
}) {
  const [inspectionResponse, setInspectionResponse] = useState();
  const [apiCallDone, setApiCallDone] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const datepickerRef = useRef();
  const storeData = useSelector((state) => state.CommonReducer);
  const dispatch = useDispatch();

  let templateIndex =
    storeData?.inspectionData?.data?.inspectiontemplates?.findIndex(
      (itm) => itm.template_id === templateId
    );
  let prevData = JSON.parse(JSON.stringify(storeData?.inspectionData?.data));
  let pdfTemplate = prevData?.inspectiontemplates[templateIndex];
  let mergeId = element?.merge_id;
  let ElementpdfData = pdfTemplate?.pdf_data?.filter(
    (item) => item?.merge_id == mergeId
  );
  let newPrevData = JSON.parse(JSON.stringify(storeData?.inspectionData?.data))
  let newPdfTemplate = newPrevData?.inspectiontemplates[templateIndex];

  const HandleUpdateYearApiCall = async (date) => {
    let formData = {
      type: "Input/Year",
      merge_id: mergeId,
      value: date,
      updated_at: await GetUTCTime(),
    };
    let payload = {
      guid: storeData?.inspectionData?.data?.guid,
      inspectiontemplates: [
        {
          ...pdfTemplate,
          pdf_data: [formData],
          pdf_categories: [],
        },
      ],
    };
    pdfTemplate.pdf_data = await mergePdfDataArray(pdfTemplate?.pdf_data || [], [formData]);
    newPdfTemplate.pdf_data = await mergePdfDataArray(newPdfTemplate?.pdf_data || [], [formData]);
    UpdateTemplateDataSpecific(dispatch,prevData,payload);
    setApiCallDone(true);
  };

  const handleYearChange = (year) => {
    const newDate = new Date(year);
    setSelectedDate(year);
    setOpen(false);
    HandleUpdateYearApiCall(newDate.getFullYear());
  };

  const handleInputClick = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  const handleClearDate = () => {
    setSelectedDate(null);
    HandleUpdateYearApiCall(null);
  };

  useEffect(() => {
    const handleClickAway = (event) => {
      if (
        datepickerRef.current &&
        !datepickerRef.current.contains(event.target)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickAway);

    return () => {
      document.removeEventListener("click", handleClickAway);
    };
  }, []);

  // useEffect(() => {
  //   setInspectionResponse(storeData);
  // }, [storeData]);

  useEffect(() => {
    if (ElementpdfData?.[0]?.value) {
      let year = moment(ElementpdfData?.[0]?.value);
      const date = new Date(year, 0, 1);
      setSelectedDate(moment(date));
    }
  }, [ElementpdfData?.[0]?.value]);

  // useEffect(() => {
  //   if (ElementpdfData?.[0]?.value) {
  //         let year = moment(ElementpdfData?.[0]?.value);
  //         const date = new Date(year, 0, 1);
  //         setSelectedDate(moment(date));
  //       }
  // }, [pdfCategoryData]);
  
  // useEffect(() => {
  //   setInspectionResponse(storeData);
  // }, []);

  return (
    <>
      <Grid
        container
        className={`${
          elementType === "inner" || elementType === "layout"
            ? "pdf_container"
            : "pdf_inner_container"
        }`}
      >
        <FormControl
          variant="standard"
          className={`forms-control w-100 ${level == 3 ? "level3_class" : ""}`}
          onKeyDown={onKeyDown}
          onClick={handleInputClick}
        >
          <label
            // className="inner_details_title"
            className={
              pdfCategoriesType == 1
                ? (elementType !== "inner" && elementType !== "layout") ||
                  selectedDate == "" ||
                  selectedDate == null
                  ? "inner_details_title"
                  : "inner_details_title_after_selection"
                : "inner_details_title"
            }
            id="categoryName"
          >
            {pdfCategoriesType == 1 ? (
              (elementType !== "inner" && elementType !== "layout") ||
              selectedDate == "" ||
              selectedDate == null ? (
                ""
              ) : (
                <DoneIcon sx={{ marginLeft: "-28px", position: "absolute" }} />
              )
            ) : (
              ""
            )}

            {element?.label}
          </label>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <div style={{ marginTop: "9px" }}>
              {selectedDate && (
                <div
                  style={{
                    display: "flex",
                    flex: 1,
                    zIndex: 10,
                    position: "absolute",
                    right: "30px",
                  }}
                >
                  {" "}
                  <IconButton
                    onClick={handleClearDate}
                    sx={{
                      ":hover": { backgroundColor: "transparent" },
                      paddingTop: "9px",
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                </div>
              )}
              <DatePicker
                ref={datepickerRef}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={handleClose}
                autoOk={true}
                openTo="year"
                views={["year"]}
                sx={{ display: "flex", flex: 1 }}
                className="dateClass"
                renderInput={(params) => <TextField {...params} />}
                value={selectedDate || null}
                onChange={handleYearChange}
              />
            </div>
          </LocalizationProvider>
        </FormControl>
      </Grid>
    </>
  );
}

export default YearElement;
